<template lang="pug">
  app-modal.historicoModal(
    :titulo="'Histórico'",
    @closeModal="closeModal",
    :width="width",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      div.extra-margin-bottom
        el-collapse(v-model='abaAtiva')
          el-collapse-item(v-for="historico in arrayHistorico" :key="historico.id")
            template(slot="title" v-if="historico.credenciado")
              el-col(style="float: left;")
                p(class="titleCollapse" style="text-align: left;") {{historico.credenciado}}
              el-col(style="float: right;")
                p(class="titleCollapse" style="text-align: right;") {{historico.data}}
            p <span class="bold">Ação:</span> {{historico.acao.nome}}
            p <span class="bold">Responsável:</span>  {{historico.responsavel}}
            p <span class="bold">Justificativa:</span> {{historico.acao.codigo === "VINCULAR" ? "Vinculação de credenciado de vistoria" : historico.justificativa}}
        div(v-if="arrayHistorico.length === 0")
          p(class="bold" style="font-size:16px;") Esse processo não possui histórico de vistoriador credenciado

</template>

<script>

import AppActionButton from '@/components/AppActionButton'
import AppModal from '@/components/AppModal.vue'
import AppDisplay from '@/components/AppDisplay'
import axios from '@/utils/api'

export default {

  components: {
    AppModal,
    AppDisplay,
    AppActionButton
  },

  props: {
    width: {
      type: Number,
      default: 850
    },
    numeroProcesso: {
      type: String
    }
  },
  data () {
    return {
      isOpen: false,
      abaAtiva: undefined,
      vistoriadorCredenciado: [],
      arrayHistorico: [],
      novoArrayHistorico: []
    }
  },
  async mounted () {
    this.showDadosCollapse()
  },

  methods: {
    closeModal () {
      this.isOpen = !this.isOpen
      this.$emit('closeModal')
    },
    async showDadosCollapse () {
      this.arrayHistorico = await axios({
        method: 'GET',
        url: `historico/credenciado/processo?numeroProcesso=${this.numeroProcesso}`
      })
      this.novoArrayHistorico = this.arrayHistorico.filter(historico => {
        return !historico.credenciado
      })
    }
  }
}

</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

  .extra-margin-bottom {
    padding: 10px;
  }

    .full-width {
    width: -webkit-fill-available;
  }

  .collapse {
    margin-top: 30px;
  }

  p.message {
    width: 80%;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .date {
    align-self: flex-end;
    text-align: end;
  }

  p {
    margin-bottom: 1vh;
    font-size: 14px;
    b {
      color: $font-dark-color;

    }
  }

  .text {
    color: $font-color;
  }

  .bold {
    font-weight: bold;
  }

  .titleCollapse{
    font-size: 16px;
    color: #909399;
  }

  @media (max-width: 780px) {
    .historicoModal {
      position: fixed !important;
      width: 375px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/AppModalHistoricoVistoriadores.vue